var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pendo-tag',{attrs:{"prefix-icon":_vm.appPrefixIcon,"data-cy":_vm.app.displayName,"type":"filter"}},[_c('pendo-app-display',{attrs:{"apps":_vm.app}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }